import React, { useEffect, useState } from "react";
import { ChakraProvider, Container, Fade, Flex } from "@chakra-ui/react";
import TotoNumberInput from "./sections/TotoNumberInput";
import LatestTotoResult from "./sections/LastestTotoResult";
import theme from "./config/theme";
import { NavigationBar } from "./sections/NavigationBar";
import ComputedResult from "./sections/ComputedResult";
import { Route, Routes } from "react-router-dom";
import FeedbackForm from "./sections/FeedbackForm";
import ReactGa from "react-ga";

export const App = () => {
  const [isComputed, setIsComputed] = useState(false);
  const [score, setScore] = useState(0);
  const [prizeMoney, setPrizeMoney] = useState("");

  useEffect(() => {
    ReactGa.initialize("UA-213501626-1");
    ReactGa.pageview("/");
  });

  return (
    <ChakraProvider theme={theme}>
      <Routes>
        <Route
          path="/"
          element={
            <Container maxWidth="container.xl" padding={0}>
              <Flex
                h={{ base: "auto", md: "100vh" }}
                py={[0, 10, 20]}
                direction={{ base: "column", md: "column" }}
              >
                <NavigationBar />
                <Flex
                  h={{ base: "auto", md: "100vh" }}
                  py={[0, 10, 20]}
                  direction={{ base: "column", md: "row" }}
                >
                  {!isComputed ? (
                    <>
                      <LatestTotoResult />
                      <TotoNumberInput
                        setIsComputed={setIsComputed}
                        setScore={setScore}
                        setPrizeMoney={setPrizeMoney}
                      />
                    </>
                  ) : (
                    <>
                      <Fade in={isComputed}>
                        <ComputedResult
                          score={score}
                          prizeMoney={prizeMoney}
                          setIsComputed={setIsComputed}
                          setScore={setScore}
                          setPrizeMoney={setPrizeMoney}
                        />
                      </Fade>
                    </>
                  )}
                </Flex>
              </Flex>
            </Container>
          }
        />
        <Route
          path="/feedback"
          element={
            <Container maxWidth="container.xl" padding={0}>
              <Flex
                h={{ base: "auto", md: "100vh" }}
                py={[0, 10, 20]}
                direction={{ base: "column", md: "column" }}
              >
                <NavigationBar />
                <Flex
                  h={{ base: "auto", md: "100vh" }}
                  py={[0, 10, 20]}
                  direction={{ base: "column", md: "row" }}
                >
                  <FeedbackForm />
                </Flex>
              </Flex>
            </Container>
          }
        />
      </Routes>
    </ChakraProvider>
  );
};
